import axios from 'axios';
import UserAuthKey from '../../../components/Common/UserAuthKey';
import { setUserData } from '../../../Redux/user/userSlice';
import {
  setSoItems,
  setSoOrderInfo,
  setIsSoLoading,
  setDoList,
  setIsLoading,
  setSubmitSuccess,
  setSubmitError,
} from '../../../Redux/complaintsDo/complaintsDoSlice';

const apiUrl = process.env.REACT_APP_OMS_API;

// Search SO number → get items + customer info
export const fetchItemsBySoNumber = async ({ soNumber, dispatch }) => {
  const bearerToken = UserAuthKey();
  dispatch(setIsSoLoading(true));
  dispatch(setSoItems([]));
  dispatch(setSoOrderInfo(null));
  try {
    const response = await axios({
      method:  'POST',
      url:     `${apiUrl}v1/orders/complaints-do/search-order`,
      headers: { Authorization: `Bearer ${bearerToken}`, 'Content-Type': 'application/json' },
      data:    { sonumber: soNumber },
    });
    const data = response?.data?.data;
    dispatch(setSoItems(Array.isArray(data?.items) ? data.items : []));
    dispatch(setSoOrderInfo({
      name:    data?.name    || '',
      phone:   data?.phone   || '',
      address: data?.address || '',
    }));
  } catch (error) {
    dispatch(setSoItems([]));
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  } finally {
    dispatch(setIsSoLoading(false));
  }
};

// Submit new DO
export const submitComplaintDo = async ({ payload, dispatch }) => {
  const bearerToken = UserAuthKey();
  dispatch(setIsLoading(true));
  dispatch(setSubmitError(null));
  try {
    const response = await axios({
      method:  'POST',
      url:     `${apiUrl}v1/orders/complaints-do/insert`,
      headers: { Authorization: `Bearer ${bearerToken}`, 'Content-Type': 'application/json' },
      data:    payload,
    });
    dispatch(setSubmitSuccess(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      dispatch(setSubmitError(error?.response?.data?.message || 'Submission failed. Please try again.'));
    }
  }
};

// Fetch DO list
export const fetchDoList = async ({ params, dispatch }) => {
  const bearerToken = UserAuthKey();
  try {
    const response = await axios({
      method:  'POST',
      url:     `${apiUrl}v1/orders/complaints-do/list`,
      headers: { Authorization: `Bearer ${bearerToken}`, 'Content-Type': 'application/json' },
      data:    { ...params },
    });
    dispatch(setDoList(response?.data));
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    }
  }
};

// Fetch DO detail by receipt_no
export const fetchDoDetail = async ({ receipt_no, dispatch }) => {
  const bearerToken = UserAuthKey();
  try {
    const response = await axios({
      method:  'POST',
      url:     `${apiUrl}v1/orders/complaints-do/detail`,
      headers: { Authorization: `Bearer ${bearerToken}`, 'Content-Type': 'application/json' },
      data:    { receipt_no },
    });
    return response?.data;
  } catch (error) {
    if (error?.response?.status === 401) {
      dispatch(setUserData(null));
      window.location.replace('/logout');
    } else {
      throw error;
    }
  }
};
